import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

const RouterHook = ({ action }) => {
  const location = useLocation();
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname !== prevPath.current) {
      prevPath.current = location.pathname;
      action();
    }

    prevPath.current = location.pathname;
  }, [location, action]);

  return null;
};

RouterHook.propTypes = {
  action: PropTypes.func.isRequired,
};

export default RouterHook;
